import React from "react";
import {defaultProps} from "recompose";
import {TableCell, TableRow} from "@mui/material";

const KeySSBloc = ({keySS, ...props}) => (
    <React.Fragment>
        {
            keySS && <TableRow item {...props}>
                <TableCell variant="head">Numéro de clé</TableCell>
                <TableCell> : </TableCell>
                <TableCell>{keySS}</TableCell>
            </TableRow>
        }
    </React.Fragment>
)

KeySSBloc.withDefaultProps = defaultProps({
    keySS: "",
    sm: 6,
    xs: 6,
    id: ""
})

export default KeySSBloc;
